import styled from 'styled-components'

export const Container = styled.div`
  margin: 8px 0;
  position: relative;
  .label {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 1; /* number of lines to show */
      line-clamp: 1;
      -webkit-box-orient: vertical;

      
      
    position: absolute;
    z-index: 5;
    top: 0;
    left: 10px;
    pointer-events: none !important;
    transform-origin: left center;

    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 140%;
    letter-spacing: 0.01em;
    padding: 1em 0.5em 0;

    color: rgba(0, 0, 0, 0.4);


    
  }
  .label.floated,
  &:focus-within .label{
      color: #BB9776;
      transform: translateY(-10px) scale(0.8);
      background: rgba(239,239,239,1);
      padding: 0 0.5em;
  }

  .inputWrapper,
  .textareaWrapper {
    isolation: isolate;
    box-sizing: border-box;
    max-width: 100%;
    font-weight: 100;
    position: relative;
    vertical-align: middle;
    input,
    textarea {
      z-index: 100;
      height: 100%;
      width: 100% !important;
      padding: 10px 15px;
      box-sizing: border-box;
      background: none;
      border: 0;
      color: #333;
      box-shadow: inset 0 0 0 2px #d6d6d6;
      -webkit-appearance: none;
      font-size: 16px;
      border-radius: 4px;
      font-family: 'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell',  'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
      /* font-family: 'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell',  'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif; */
      &:focus {
        outline: none;
      }
    }
    &::before,
    &::after {
      box-sizing: inherit;
      content: '';
      position: absolute;
      width: 100%;
      height: 100%;
      pointer-events: none;
      z-index: 1;
    }

    & {
      transition: color 0.15s;
    }
    &::before,
    &::after {
      border: 2px solid transparent;
      width: 0;
      height: 0;
      border-radius: 4px;
    }
    &::before {
      top: 0;
      left: 0;
    }
    &::after {
      bottom: 0;
      right: 0;
    }
    &:focus-within,
    &:hover {
      color: #333;
    }
    &:focus-within::before,
    &:hover::before,
    &:focus-within::after,
    &:hover::after {
      width: 100%;
      height: 100%;
    }
    &:focus-within::before,
    &:hover::before {
      border-top-color: #b99777;
      border-right-color: #b99777;
      transition: border-color 0.2s ease-in-out, width 0.15s ease-in-out, height 0.15s ease-in-out 0.15s;
    }
    &:focus-within::after,
    &:hover::after {
      border-bottom-color: #b99777;
      border-left-color: #b99777;
      transition: border-color 0.2s ease-in-out 0.3s, width 0.15s ease-in-out 0.3s, height 0.15s ease-in-out 0.45s;
    }
  }
  .inputWrapper {
    height: 45px;
  }
  .textareaWrapper {
    min-height: 45px;

    textarea {
      margin: -1.5px 0;
    }
  }
  .invalid__info {
    padding-left: 10px;
    font-size: .9rem;
    color: darkred;
  }
  .err {
    background-color: lightpink;
  }
`

export const style = {}

export default style
